import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useConnect } from 'redux-bundler-hook';
import Tooltip from 'root/components/molecules/Tooltip';

import {
  StyledAvatarWrapper,
  StyledBoardAvatar,
  StyledRemainingWorkspaces,
  StyledRemainingWorkspacesCount,
  StyledWorkspaceTeamList,
} from './styles';

const TeamWorkspaceList = ({ disabled, boardIDs }) => {
  const { boardsById } = useConnect('selectBoardsById');
  const ref = useRef(null);
  const [hover, setHover] = useState(false);
  const boards = boardIDs.map((id) => boardsById[id]).filter((b) => b);

  if (!boards.length) return null;

  // display first three Team
  const firstThreeWorkspaces = boards.slice(0, 3);

  // get the Team beyond the first three to display in a tooltip
  const remainingWorkspaces = boards.slice(3);

  // get a count for the remaining workspaces
  const remainingWorkspacesLength = remainingWorkspaces.length;

  return (
    <StyledWorkspaceTeamList>
      {firstThreeWorkspaces.length
        ? firstThreeWorkspaces.map(({ mongoId }) => (
            <StyledAvatarWrapper key={mongoId}>
              <StyledBoardAvatar id={mongoId} withTooltip={!disabled} />
            </StyledAvatarWrapper>
          ))
        : null}
      {remainingWorkspacesLength ? (
        <StyledRemainingWorkspaces
          onMouseEnter={() => !disabled && setHover(true)}
          onMouseLeave={() => !disabled && setHover(false)}
          ref={ref}
        >
          <StyledRemainingWorkspacesCount>{`+${remainingWorkspacesLength}`}</StyledRemainingWorkspacesCount>
          <Tooltip
            active={hover}
            parent={ref}
            position="bottom"
            variant="arrow"
          >
            {remainingWorkspaces.map(({ id, name }) => (
              <p key={id}>{name}</p>
            ))}
          </Tooltip>
        </StyledRemainingWorkspaces>
      ) : null}
    </StyledWorkspaceTeamList>
  );
};

TeamWorkspaceList.propTypes = {
  boardIDs: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

TeamWorkspaceList.defaultProps = {
  boardIDs: [],
  disabled: false,
};

export default TeamWorkspaceList;
